module.exports = __webpack_public_path__ + "static/media/image7.6cbb4888.png";